//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { TRACKING_ACTION, TRACKING_CATEGORY } from '@tracker/trackerModel';

import { pendoTracker } from 'app/initialization/pendo/pendo-tracker';

/**
 * The standard method to send information on a user event to our tracking systems.
 */
export const recordEvent = (
  category: TRACKING_CATEGORY,
  action: TRACKING_ACTION,
  label?: string,
  value?: string,
) => {
  ga('send', 'event', category, action, label, value);
  pendoTracker.track(`ga_${action}`, {
    category,
    label: label ?? '',
    value: value ?? '',
  });
};

/**
 * A specialized recordEvent shortcut for recording counts, such as the quantity of items
 * added to the library in upload events.
 */
export const recordCount = (
  category: TRACKING_CATEGORY,
  action: TRACKING_ACTION,
  label: string,
  value: string | number,
) => {
  return recordEvent(category, action, `${label}=${value}`, value.toString());
};

/**
 * Used to ensure GA knows about all page changes in our Angular app.
 */
export const updatePage = (url: string, sendView: boolean) => {
  ga('set', 'page', url);
  if (sendView) {
    ga('send', 'pageview');
  }
};
